import React, { useState, Suspense, useContext, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Loader, toaster, Notification, Modal } from "rsuite";
import UserContext from "../../app/context/UserContext";
import { useTranslation } from "react-i18next";
import axios from "axios";
import usePost from "../../customhooks/UsePost";
import ApplyNowNewLayout from "../createProfile/ApplyNowNewLayout";
import { useLoaderData } from "react-router-dom";
import ToasterNotification from "../../utilities/ToasterNotification";
const PasswordsManagement = React.lazy(() =>
  import("../account/PasswordsManagement")
);
const NewLinkProfileLayout = React.lazy(() => import("./NewLinkProfileLayout"));
const UploadResumeModalNewLayout = React.lazy(() =>
  import("../account/tabs/resume/UploadResumeModalNewLayout")
);

const ApplyNowModal = React.lazy(() => import("./ApplyNowModal"));
const CreateProfileModal = React.lazy(() =>
  import("../createProfile/CreateProfileModal")
);
const LinkProfile = React.lazy(() => import("../jobs/LinkProfile"));
const DuplicateProfile = React.lazy(() =>
  import("../createProfile/DuplicateProfile")
);

function NewApplyNow({
  campaignID,
  setupdatadataMri,
  companyID,
  campaignName,
}) {
  const loaderDetails = useLoaderData();
  const { t } = useTranslation();
  const [openApplyNow, setOpenApplyNow] = useState(false);
  const [openCreateProfile, setOpenCreateProfile] = useState(false);
  const [openLinkProfile, setOpenLinkProfile] = useState(false);
  const [openDuplicate, setOpenDuplicate] = useState(false);
  const [duplicateProfiles, setDuplicateProfiles] = useState([]);

  const { user, setUser } = useContext(UserContext);
  const [page, setPage] = useState("guest");
  const [enableApply, setEnableApply] = useState(true);
  const [cookie, setCookie] = useState(null);
  const [guestCampaignIDs, setGuestCampaignIDs] = useState([]);
  const [guestCookie, setGuestCookie] = useState("");
  const [openPasswordManagement, setOpenPasswordManagement] = useState(false);
  const {
    post: guestUser,
    data: guestData,
    isLoading: guestuserdataloaging,
  } = usePost("/user/guestuserdeatails ");
  const [showUploadResumeModal, setShowUploadResumeModal] = useState(false);

  // console.log("campaignIDcampaignID", campaignID);
  // console.log("useruseruseruser", guestData);

  const {
    post: resumeDetails,
    data,
    isLoading: resumeDetailsLoading,
    error,
  } = usePost("/getresumedetails");

  useEffect(() => {
    console.log("enterrrrrr", campaignID);
    if (user) {
      if (user?.attachedCampaigns && user?.attachedCampaigns?.length > 0) {
        if (user?.attachedCampaigns?.includes(campaignID)) {
          setEnableApply(false);
        } else {
          setEnableApply(true);
        }
      }
    } else {
      // handleEnableUsingCookie()
      // if(cookieDetails?.Guest_User_ResumeID){
      if (guestCampaignIDs?.includes(campaignID)) {
        setEnableApply(false);
      } else {
        setEnableApply(true);
      }
      // }
    }
  }, [user, campaignID, guestCampaignIDs]);

  useEffect(() => {
    handleEnableUsingCookie();
  }, [
    openApplyNow,
    openCreateProfile,
    openLinkProfile,
    openDuplicate,
    guestCookie,
    campaignID
  ]);
  const handleEnableUsingCookie = async () => {
    let cookieDetails = await axios.get(
      window.location.origin + "/jsv4/webapi/getcookie"
    );
    cookieDetails = cookieDetails?.data;
    if (cookieDetails?.Guest_User_ResumeID) {
      resumeDetails({
        companyID: companyID,
        resumeID: cookieDetails?.Guest_User_ResumeID,
      })
        .then((res) => {
          if (res) {
            setGuestCampaignIDs(res?.campaignID);
            // if(res?.campaignID?.includes(campaignID)){
            //   setEnableApply(false)
            // }else{
            //   setEnableApply(true)
            // }
          }
        })
        .catch((error) => {
          console.error("Error while fetching Resume:", error);
        });
    }
  };

  async function handleApply() {
    if (user && Object.keys(user)?.length > 0) {
      setPage("login");
      if (user?.resumeID != "") {
        setOpenLinkProfile(true);
      } else {
        setOpenCreateProfile(true);
      }
    } else {
      try {
        let cookieDetails = await axios.get(
          window.location.origin + "/jsv4/webapi/getcookie"
        );
        cookieDetails = cookieDetails?.data;
        if (cookieDetails["Guest_User_ResumeID"]) {
          setCookie(cookieDetails["Guest_User_ResumeID"]);
          let guestUserDetails = await guestUser({
            resumeID: cookieDetails["Guest_User_ResumeID"],
            companyID: loaderDetails?.companyID,
          });
          if (
            guestUserDetails?.result &&
            Object.keys(guestUserDetails?.result)?.length > 0
          ) {
            if (
              guestUserDetails?.result?.hashed_password ||
              guestUserDetails?.result?.googleToken ||
              guestUserDetails?.result?.outlookToken ||
              guestUserDetails?.result?.linkedInToken
            ) {
              setOpenLinkProfile(true);
              setPage("guest");
            } else {
              setOpenPasswordManagement(true);
            }
          } else {
            setOpenLinkProfile(true);
            setPage("guest");
          }
        } else {
          setPage("guest");
          setOpenCreateProfile(true);
        }
      } catch (error) {
        console.log("Error in getCookies : ", error);
      }
    }
  }
  const [notduplicate, setnotduplicate] = useState(false);

  return (
    <>
      {enableApply ? (
        <Button
          className="rounded-pill"
          variant="primary"
          onClick={() => {
            handleApply();
          }}
        >
          {t("applyNow", { defaultValue: "Apply Now" })}
        </Button>
      ) : (
        <Button
          className="rounded-pill"
          variant="secondary"
          onClick={() => {
            // toaster.push(
            //   <Notification
            //     type={"info"}
            //     header={t("info", { defaultValue: "info" })}
            //     closable
            //   >
            //     {t("youHaveAlreadyAppliedForThisJob", {
            //       defaultValue: "You have already applied for this job",
            //     })}
            //   </Notification>,
            //   { placement: "topEnd" }
            // );
            ToasterNotification({
              type: "info",
              i18keyFormat: "youHaveAlreadyAppliedForThisJob",
              message: "You have already applied for this job",
              options: { position: "top-right", autoClose: 5000 },
            });
          }}
        >
          {t("applied", { defaultValue: "Applied" })}
        </Button>
      )}

      {openApplyNow && (
        <>
          <React.Suspense
            fallback={
              <Loader center speed="normal" size="sm" backdrop={true} />
            }
          >
            <ApplyNowModal
              openModal={openApplyNow}
              setOpenModal={setOpenApplyNow}
              from={"NewApplyNow"}
              openCreateProfile={openCreateProfile}
              setOpenCreateProfile={setOpenCreateProfile}
              setOpenLinkProfile={setOpenLinkProfile}
              setPage={setPage}
              setupdatadataMri={setupdatadataMri}
            />
          </React.Suspense>
        </>
      )}

      {openCreateProfile && (
        <Suspense
          fallback={<Loader center speed="normal" size="sm" backdrop={true} />}
        >
          <ApplyNowNewLayout
            open={openCreateProfile}
            setOpen={setOpenCreateProfile}
            openModal={openApplyNow}
            setOpenModal={setOpenApplyNow}
            campaignID={campaignID}
            page={page}
            setOpenDuplicate={setOpenDuplicate}
            setDuplicateProfiles={setDuplicateProfiles}
            setCookie={setCookie}
            setupdatadataMri={setupdatadataMri}
            notduplicate={notduplicate}
            setGuestCookie={setGuestCookie}
            companyID={companyID}
            setPage={setPage}
            setOpenLinkProfile={setOpenLinkProfile}
            campaignName={campaignName}
          />
          {/* <CreateProfileModal
            open={openCreateProfile}
            setOpen={setOpenCreateProfile}
            campaignID={campaignID}
            page={page}
            setOpenDuplicate={setOpenDuplicate}
            setDuplicateProfiles={setDuplicateProfiles}
            setCookie={setCookie}
            setupdatadataMri={setupdatadataMri}
            notduplicate={notduplicate}
            setGuestCookie={setGuestCookie}
            companyID={companyID}
          ></CreateProfileModal> */}
        </Suspense>
      )}

      {openLinkProfile && (
        <Suspense
          fallback={<Loader center speed="normal" size="sm" backdrop={true} />}
        >
          <NewLinkProfileLayout
            openLinkProfile={openLinkProfile}
            setOpenLinkProfile={setOpenLinkProfile}
            user={user}
            setUser={setUser}
            campaignID={campaignID}
            page={page}
            resumeID={user?.resumeID ? user?.resumeID : cookie}
            setupdatadataMri={setupdatadataMri}
            campaignName={campaignName}
            showUploadResumeModal={showUploadResumeModal}
            setShowUploadResumeModal={setShowUploadResumeModal}
            companyID={companyID}
          />
          {/* <LinkProfile
            openLinkProfile={openLinkProfile}
            setOpenLinkProfile={setOpenLinkProfile}
            user={user}
            setUser={setUser}
            campaignID={campaignID}
            page={page}
            resumeID={cookie}
            setupdatadataMri={setupdatadataMri}
          /> */}
        </Suspense>
      )}

      {openDuplicate && (
        <React.Suspense
          fallback={<Loader center speed="normal" size="sm" backdrop={true} />}
        >
          <DuplicateProfile
            open={openDuplicate}
            setOpen={setOpenDuplicate}
            duplicateProfiles={duplicateProfiles}
            campaignID={campaignID}
            page={page}
            setCookie={setCookie}
            setupdatadataMri={setupdatadataMri}
            setnotduplicate={setnotduplicate}
            setOpenCreateProfile={setOpenCreateProfile}
          />
        </React.Suspense>
      )}
      {openPasswordManagement && (
        <Modal
          open={openPasswordManagement}
          onClose={() => {
            setOpenPasswordManagement(false);
          }}
          overflow={false}
          size="lg"
        >
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <React.Suspense
              fallback={
                <Loader center speed="normal" size="sm" backdrop={true} />
              }
            >
              <PasswordsManagement
                setOpenLinkProfile={setOpenLinkProfile}
                setPage={setPage}
                setOpenPasswordManagement={setOpenPasswordManagement}
                from="ApplyNow"
                email={guestData?.result?.email ? guestData?.result?.email : ""}
              />
            </React.Suspense>
          </Modal.Body>
        </Modal>
      )}
      {showUploadResumeModal && (
        <>
          <React.Suspense
            fallback={
              <Loader center speed="normal" size="sm" backdrop={true} />
            }
          >
            <UploadResumeModalNewLayout
              showUploadResumeModal={showUploadResumeModal}
              setShowUploadResumeModal={setShowUploadResumeModal}
              data={{ _id: user?.resumeID ? user?.resumeID : cookie }}
              openLinkProfile={openLinkProfile}
              setOpenLinkProfile={setOpenLinkProfile}
              companyID={companyID}
            />
          </React.Suspense>
        </>
      )}
    </>
  );
}
export default NewApplyNow;
